import {Card, ListGroup, Table} from "react-bootstrap";
import {HistoryProduct} from "../Product/HistoryProduct";
import {useEffect, useState} from "react";
import {GetDateFromString} from "../../common/Helpers/jsHelpers";
import Accordion from 'react-bootstrap/Accordion';
import {React, useRef} from "react";
import {ConfirmPopup} from "primereact/confirmpopup";
import { Toast } from 'primereact/toast';
import {salesOrderAPI} from "../../api/api";
import {useNavigate} from "react-router-dom";
import style from './SalesOrderNew.module.css'
import {useCartContext} from "../../Context/CartContext";
import {Button} from "primereact/button";
import {useWindowDimensions} from "../../Context/WindowDimensionsContext";

export const SalesOrderHeaderNew = ({
                            id,
                            crmId,
                            number,
                            productList,
                            data,
                            totalAmount,
                            totalDeltaAmount,
                            shipmentState,
                            salesOrderState,
                            salesOrderStateCode,
                            actualShipmentDate,
                            requestDeliveryBy,
                            loadSalesOrder,
                            isDebtOverdue,
                            toast }) => {

    const [products, setProducts] = useState([]);
    const [date, setDate] = useState("");
    const [requestDeliveryByDate, setRequestDeliveryByDate] = useState("");
    const [actualShipmentByDate, setActualShipmentByDate] = useState("");
    const [orderSum, setOrderSum] = useState(0.00);

    const {setInitCart} = useCartContext();
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    const cancelButton = useRef(null);
    const [visible, setVisible] = useState(false);

    const navigate = useNavigate()

    const orderSumHandler = (list) => {
        let sum = 0.00;
        for (const element of list) {
            sum += element.Tax;
        }
        setOrderSum(sum.toFixed(2));
    }

    const repeatOrder = async () => {
        debugger
        const {data} = await salesOrderAPI.repeatOrder(id)
        const result = JSON.parse(data);
        if (result.isSucccess) {
            setInitCart().then();
            navigate("/cart")
        } else {

        }
    }

    const cancelOrder = async () => {
        debugger
        const cancelModel = {SalesOrderId: crmId};

        const {data} = await salesOrderAPI.cancelOrder(cancelModel)
        const result = JSON.parse(data);
        if(!result.isSucccess)
        {
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Помилка',
                clearPrevious: true,
                detail: 'Не вдалося скасувати замовлення. Причина:  ' + result.message,
                life: 5000
            });
        }
        loadSalesOrder().then();
    }

    const setDateFormString = () => {
        if (requestDeliveryBy) {
            setRequestDeliveryByDate(GetDateFromString(requestDeliveryBy))
        }
        if(actualShipmentDate){
            setActualShipmentByDate(GetDateFromString(actualShipmentDate))
        }
        if (data) {
            setDate(GetDateFromString(data))
        }
    }
    
    const accept = () => {
        cancelOrder().then();
        setVisible(false);
    };

    const reject = () => {
        setVisible(false);
    };

    const onHide =() =>{
        setVisible(false);
    }
    const onShow = () =>{
        setVisible(true);
        setTimeout(() =>{
            setVisible(false);
        },5000)
    }

    const renderFooter = () => {
        return (
            <div style={{float: 'right', margin:'5px'}}>
                <Button style={{marginRight:'5px', padding:'5px 10px'}} severity="danger" label="Так" icon="pi pi-check" onClick={accept} />
                <Button style={{padding:'5px 10px'}} label="Ні" icon="pi pi-times" onClick={reject} className="p-button-secondary" />
            </div>
        );
    };

    const invoiceDebtSchema = () => {
        if(totalDeltaAmount > 0 && isDebtOverdue){
            return (
                <div style={{color: "red"}}>{totalDeltaAmount.toLocaleString('uk-UA', {style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'})}</div>
            )
        }
        else if(totalDeltaAmount > 0 && !isDebtOverdue){
            return(
                <div style={{color: "#1462d6"}}>{totalDeltaAmount.toLocaleString('uk-UA', {style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'})}</div>
            )
        }
        else if(totalDeltaAmount === 0){
            return(
                <div style={{color: "green"}}>Відсутня</div>
            )
        }
    }

    useEffect(() => {
        setDateFormString();
    }, [actualShipmentDate, data, requestDeliveryBy])

    useEffect(() => {
        if (productList.length !== 0) {
            setProducts(productList);
            orderSumHandler(productList)
        }
    }, [productList])

    if (productList.length === 0) {
        return (<div></div>)
    }

    if(viewPortWidth < 1050)
    {
        return (
            <>
                        <span className={` ${style.headerWrapper}`}>

                            <div className={style.firstColumn}>

                                <div className={style.numberDate}>
                                    <div className={style.optionDescription}>{date}</div>
                                    <div>№ {number}</div>
                                </div>

                                <div className={style.shipmentState}>
                                    <div className={style.optionDescription}>Cтан доставки:</div>
                                    <div>{shipmentState}</div>
                                </div>

                                 <div className={style.salesOrderState}>
                                        <div className={style.optionDescription}>Стан замовлення:</div>
                                         {salesOrderStateCode == 4 ? <div style={{color: "red"}}>{salesOrderState}</div> :
                                             <div>{salesOrderState}</div>}
                                 </div>

                            </div>

                            <div className={style.secondColumn}>

                                <div className={style.sum}>
                                    <div className={style.optionDescription}>Сума замовлення:</div>
                                    <div>{totalAmount.toLocaleString('uk-UA', {
                                        style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'
                                    })} </div>
                                </div>

                                <div className={style.dz}>
                                    <div className={style.optionDescription}>Заборгованність за рахунком:</div>
                                        {invoiceDebtSchema()}
                                </div>

                            </div>

                        </span>
            </>
        )
    }

    return (
        <> 
                        <span className={` ${style.headerWrapper}`}>
                            <div className={style.numberDate}>
                                <div className={style.optionDescription}>{date}</div>
                                <div>№ {number}</div>
                            </div>

                            <div className={style.salesOrderState}>
                                <div className={style.optionDescription}>Стан замовлення:</div>
                                {salesOrderStateCode == 4 ? <div style={{color: "red"}} >{salesOrderState}</div> : <div>{salesOrderState}</div>}
                            </div>

                            <div className={style.shipmentState}>
                                <div className={style.optionDescription}>Cтан доставки:</div>
                                <div>{shipmentState}</div>
                            </div>



                            <div className={style.dz}>
                                <div className={style.optionDescription}>Заборгованність за рахунком:</div>
                                {invoiceDebtSchema()}
                            </div>

                            <div className={style.sum}>
                                <div className={style.optionDescription}>Сума замовлення:</div>
                                <div>{totalAmount.toLocaleString('uk-UA', {
                                    style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'
                                })} </div>
                            </div>

                        </span>
        </>
    )
}